// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/app.css
// module id = MrK1
// module chunks = 73